import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Loader2 } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import BeforeAfterSlider from "../components/BeforeAfterSlider";

const API = process.env.REACT_APP_BACKEND_URL;

export default function Gallery() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useLanguage();

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await axios.get(`${API}/api/gallery`);
        setProjects(res.data);
      } catch (err) {
        // ignore fetch errors; gallery simply shows empty state
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  return (
    <div className="min-h-screen bg-neutral-950 text-white pt-20" data-testid="gallery-page">
      <section className="py-20 bg-black border-b border-neutral-800">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 text-white">
            {t.gallery.title} <span className="text-red-600">{t.gallery.title_red}</span>
          </h1>
          <p className="text-xl text-neutral-400 max-w-2xl mx-auto">
            {t.gallery.subtitle}
          </p>
          <p className="text-sm text-neutral-500 mt-3">{t.gallery.slider_hint}</p>
        </div>
      </section>

      <section className="py-16 container mx-auto px-4">
        {loading ? (
          <div className="flex justify-center py-20" data-testid="gallery-loading">
            <Loader2 className="animate-spin text-red-600 h-10 w-10" />
          </div>
        ) : projects.length === 0 ? (
          <div className="text-center py-20 text-neutral-500" data-testid="gallery-empty">
            {t.gallery.empty}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-testid="gallery-grid">
            {projects.map((p) => (
              <div key={p.id} data-testid={`gallery-project-${p.id}`} className="space-y-3">
                <BeforeAfterSlider
                  beforeSrc={`${API}${p.beforeUrl}`}
                  afterSrc={`${API}${p.afterUrl}`}
                  beforeLabel={t.gallery.before}
                  afterLabel={t.gallery.after}
                />
                {p.title && <h3 className="text-xl font-bold text-white">{p.title}</h3>}
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
